const apiKey = {
  USER_ID: 'user_cptW0h8INgOTtHc19E1Rt',
  TEMPLATE_ID: 'template_k37olso',
  SERVICE_ID: 'service_vqqswph',
  ACCESS_TOKEN: 'b98a05c1d0548886f70286689221fc69',
}
export default apiKey
